import styled from 'styled-components';

const ResourcesMenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  .toolbox-link {
    display: flex;
    margin-bottom: 25px;
  }
  .resources-menu-cta-col {
    margin-right: 70px;
    width: 450px;
    flex: 5;
    p {
      margin-top: 10px;
    }
  }

  .toolbox-title {
    align-items: center;
    display: flex;
    margin-right: 35px;

    h5 {
      margin: 4px 0 0 8px;
      font-weight: 500;
    }

    img {
      width: 36px;
      height: 36px;
    }
  }

  .toggle {
    background: transparent !important;
    flex: 4;
    padding: 0px;
    width: 370px;
    .toggle--switch {
      height: 46px;
      margin: 0px 0px 15px 0px;
      padding: 0px;
      label {
        background: var(--grey-2) !important;
        border-radius: 2px;
        .toggle--toggle:before {
          border-radius: 2px;
        }
        .toggle--title-container {
          .toggle--title {
          }
        }
      }
    }
  }
  .toggle--content-container {
    .simple-nav-col {
      width: 50% !important;
    }
  }
  .data-layer-form {
    justify-content: flex-start !important;
    margin: 0;

    button {
      color: var(--white);
    }
  }
  .resources-menu-cta-col {
    .resource-subscribe-form--legal-info {
      p {
        a {
          color: var(--titan-blue-3) !important;
        }
      }
    }
  }
`;

export { ResourcesMenuContainer };
